export default __webpack_public_path__ + "static/media/newsletter_bg.8ed09de0.png";